import { ChangeDetectionStrategy, Component, computed, input, output, Signal } from '@angular/core';

import { DpProductSubcategoriesSwitcherModel } from '../../models';

@Component({
    selector: 'dp-product-subcategory-switcher',
    templateUrl: './product-subcategory-switcher.component.html',
    styleUrl: './product-subcategory-switcher.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DpProductSubcategorySwitcherComponent {
  switcher = input.required<DpProductSubcategoriesSwitcherModel>();
  items: Signal<number[]> = computed(() => new Array(this.switcher()?.totalLists).fill(0).map((_, index) => index));
  changeActive = output<number>();
}
